<apple-pay-button #applePayButton buttonstyle="black" (click)="onApplePayButtonClick()" (keydown)="onKeyDown($event)"></apple-pay-button>
